const common = {
  // Nav
  nav_home: 'Startseite',
  nav_books: 'Bücher',
  nav_courses: 'Kurse',
  nav_mentorship: 'Mentoria SÍLEX',
  nav_webinars: 'Webinare',
  nav_about: 'Über uns',
  nav_contact: 'Kontakt',
  nav_links: 'Links',
  nav_enter: 'Anmelden',
  nav_my_courses: 'Meine Kurse',
  nav_community: 'Community',
  nav_ranking: 'Rangliste',
  nav_certificates: 'Zertifikate',
  // Auth
  auth_login_title: 'Auf Ihr Konto zugreifen',
  auth_login_subtitle: 'Mit E-Mail oder sozialen Netzwerken anmelden',
  auth_register_title: 'Konto erstellen',
  auth_register_subtitle: 'Registrieren Sie sich, um auf Kurse zuzugreifen',
  auth_forgot_title: 'Passwort zurücksetzen',
  auth_forgot_subtitle: 'Wir senden Ihnen einen Link per E-Mail',
  auth_tab_login: 'Anmelden',
  auth_tab_register: 'Konto erstellen',
  auth_email: 'E-Mail',
  auth_password: 'Passwort',
  auth_name: 'Vollständiger Name',
  auth_confirm_password: 'Passwort bestätigen',
  auth_forgot_link: 'Passwort vergessen',
  auth_btn_login: 'Mit E-Mail anmelden',
  auth_btn_register: 'Kostenloses Konto erstellen',
  auth_btn_forgot: 'Wiederherstellungslink senden',
  auth_or: 'oder fortfahren mit',
  auth_or_register: 'oder registrieren mit',
  auth_google: 'Mit Google fortfahren',
  auth_facebook: 'Mit Facebook fortfahren',
  auth_apple: 'Mit Apple fortfahren',
  auth_back_login: '← Zurück zum Login',
  auth_terms: 'Mit der Anmeldung stimmen Sie unseren',
  auth_terms_link: 'Nutzungsbedingungen',
  auth_privacy_link: 'Datenschutzrichtlinie',
  auth_and: 'und',
  // Livros page
  livros_hero_badge: 'Vollständige Bibliothek',
  livros_hero_title: 'E-Books & Bücher',
  livros_hero_subtitle: 'Wissen, das transformiert. Wähle dein nächstes Buch und beginne deine Entwicklungsreise.',
  livros_filter_all: 'Alle',
  livros_filter_pdf: 'E-Book PDF',
  livros_filter_print: 'Gedruckt',
  livros_search_placeholder: 'Buch oder Thema suchen...',
  livros_btn_buy: 'Jetzt Kaufen',
  livros_btn_amazon: 'Amazon',
  livros_btn_details: 'Details ansehen',
  livros_pages: 'Seiten',
  livros_readers: 'Leser',
  livros_cta_title: 'Zugang zu allen Büchern?',
  livros_cta_subtitle: 'Abonniere SB Family und erhalte unbegrenzten Zugang zur gesamten Bibliothek + Kurse + Gruppen-Mentoring.',
  livros_cta_btn: 'Abo erkunden',
  livros_stat_books: 'Veröffentlichte Bücher',
  livros_stat_readers: 'Zufriedene Leser',
  livros_stat_rating: 'Durchschnittsbewertung',
  livros_stat_editions: 'Überarbeitete Auflagen',
  // Language
  lang_label: 'Sprache',
  lang_pt: 'Português',
  lang_es: 'Español',
  lang_en: 'English',
  lang_fr: 'Français',
  lang_de: 'Deutsch',
  lang_it: 'Italiano',
  lang_ja: '日本語',
};

export default common;
